export default __webpack_public_path__ + "resetPassword.1df522ed.svg";